import React, { Component } from 'react';
import Paper from 'material-ui/Paper';
import jwt_decode from 'jwt-decode';
import { connect } from 'react-redux';
// Composants
import MenuTop from '../../components/menuTop/MenuTop';
import DialogAlertError from '../../components/dialogAlertError/DialogAlertError';
// Enum
import COOKIES from '../../enums/CookieEnum';
// Store
import { closeDialogErrorAction } from '../../store/error/ErrorActions';
import { getUserDataAction, setBasicDataUser, redirectUserLoginAction } from '../../store/user/UserActions';
// Webservices
import LoginService from '../../services/LoginService';
// Utils
import { getCookie } from '../../utils/CookieUtils';
// Style
import './PageLayout.css';

const paperStyle = {
    margin: 0,
    padding: '1%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    flex: 1
};

/*************************************************
 * ************* Mapping du store ****************
 *************************************************/

const mapStateToProps = (state) => ({
    errorMessage: state.errorState.errorMessage,
    isLoaded: state.userState.isLoaded,
    userProfile: state.userState.userData ? state.userState.userData.profile : null,
    language: state.languageState.language
});

const mapDispatchToProps = (dispatch) => ({
    /**
     * Ferme la modal d'erreur
     */
    cleanError: () => dispatch(closeDialogErrorAction()),
    /**
     * Redirige vers la page de login
     */
    redirectLogin: () => dispatch(redirectUserLoginAction()),
    /**
     * Met dans le store les informations récupéré du token
     * @param login
     */
    setBasicDataUser: (login) => dispatch(setBasicDataUser(login)),
    /**
     * Récupère les informations de l'utilisateur
     * @param name
     */
    getUserData: () => dispatch(getUserDataAction())
});

class PageLayout extends Component {

    /**********************************************************
     * ******************** LifeCycle *************************
     **********************************************************/

    componentWillMount(){
        const token = getCookie(COOKIES.SID);
        if (token) {
            try {
                jwt_decode(token);
                // Et on recupère les infos complementaires via un WS
                this.props.getUserData();
            } catch (err) {
                this.props.redirectLogin();
            }
        } else {
            this.props.redirectLogin();
        }
    }

    render() {
        // Si l'on a pas encore les données de l'utilisateur on ne retourne rien par sécurité
        if (!this.props.isLoaded) {
            return null;
        }

        const page = React.cloneElement(this.props.children, {
            language: this.props.language,
            userProfile: this.props.userProfile
        });

        return(
            <div className="container">
                <div className="main">
                    <div className="header">
                        <MenuTop userProfile={this.props.userProfile}
                                 redirectLogin={this.disconnectUser.bind(this)}/>
                    </div>
                    <div className="content">
                        <Paper zDepth={1} style={paperStyle}>
                            {page}
                        </Paper>
                    </div>
                </div>
                {this.props.errorMessage ?
                    <DialogAlertError errorMessage={this.props.errorMessage}
                                      open={true}
                                      onClose={this.props.cleanError}/>
                    : null
                }
            </div>
        );
    }

    disconnectUser() {
        LoginService.disconnect().then(() => {
            this.props.redirectLogin();
        }).catch(() => {
            this.props.redirectLogin();
        });
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(PageLayout);



// WEBPACK FOOTER //
// ./src/ui/pageLayout/PageLayout.js